module.exports = __webpack_public_path__ + "img/icon_success.774fadef.svg";